import { useState, useEffect } from 'react';
import { doc, getDoc, setDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { WhoWeAreContent, DEFAULT_WHO_WE_ARE_CONTENT } from '../types/Content';

export const useWhoWeAreContent = () => {
  const [content, setContent] = useState<WhoWeAreContent>(DEFAULT_WHO_WE_ARE_CONTENT);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const docRef = doc(db, 'content', 'whoWeAre');
    
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        setContent(docSnap.data() as WhoWeAreContent);
      } else {
        // Initialize with default content if it doesn't exist
        setDoc(docRef, DEFAULT_WHO_WE_ARE_CONTENT).catch(err => {
          console.error("Error initializing WhoWeAre content:", err);
        });
      }
      setLoading(false);
    }, (err) => {
      console.error("Error fetching WhoWeAre content:", err);
      setError("Erreur lors du chargement du contenu.");
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const updateContent = async (newContent: WhoWeAreContent) => {
    try {
      await setDoc(doc(db, 'content', 'whoWeAre'), newContent);
      return true;
    } catch (err) {
      console.error("Error updating WhoWeAre content:", err);
      throw err;
    }
  };

  return { content, loading, error, updateContent };
};
